/**
 * Pie del panel: de quién es el producto.
 *
 * Es un componente y no un bloque escrito adentro de `App.tsx` por una razón
 * concreta: el banco de pruebas arma su propio armazón, y todo lo que se
 * escribe dos veces termina distinto. Ya pasó con la barra de pestañas, que en
 * el banco tenía otras y en otro orden, y una captura de eso no muestra el
 * producto: muestra otro.
 *
 * Va en el panel y no en las pantallas sin sesión porque ahí el logo ya está
 * arriba de cada tarjeta. Quien usa el panel todos los días, en cambio, no veía
 * en ningún lado de quién es lo que está mirando.
 */
export function PieVoxcom() {
  return (
    <footer className="pie">
      {/*
        Decorativo con etiqueta: acá el logo **sí** es la información —es lo que
        dice de quién es el producto— así que a diferencia del de la pantalla de
        acceso, este se anuncia.
      */}
      <span className="pie-logo" role="img" aria-label="Voxcom" />
      <p>
        <strong>VoxObservability</strong> es un producto de Voxcom.{' '}
        {/* El año se calcula: escrito a mano queda viejo en enero y nadie se da
            cuenta hasta que lo ve un cliente. */}
        © {new Date().getFullYear()} Voxcom. Todos los derechos reservados.
      </p>
    </footer>
  );
}
